import { render, staticRenderFns } from "./StatisticsIncoming.vue?vue&type=template&id=3c6768f0&"
import script from "./StatisticsIncoming.vue?vue&type=script&lang=js&"
export * from "./StatisticsIncoming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports